import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LoadBalancingGroup, LoadBalancingGroupState } from './types';

const initialState: LoadBalancingGroupState = {
  loading: false,
  error: undefined,
  current: undefined,
  selectedItemId: undefined,
};

const loadBalancingGroupSlice = createSlice({
  name: 'loadBalancingGroupSlice',
  initialState,
  reducers: {
    getCurrentLoadBalancingGroupAction: (
      state: LoadBalancingGroupState,
      action: PayloadAction<{ selectedItemId: string; organisationId: string }>,
    ) => ({
      ...state,
      selectedItemId: action.payload.selectedItemId,
      loading: true,
      error: undefined,
    }),
    setCurrentLoadBalancingGroupAction: (
      state: LoadBalancingGroupState,
      action: PayloadAction<{ loadBalancingGroup: LoadBalancingGroup }>,
    ) => ({
      ...state,
      selectedItemId: action.payload.loadBalancingGroup.id,
      loading: false,
      error: undefined,
      current: action.payload.loadBalancingGroup,
    }),
    setLoadBalancingGroupErrorAction: (
      state: LoadBalancingGroupState,
      action: PayloadAction<{ error: Error; selectedItemId: string }>,
    ) => ({
      ...state,
      selectedItemId: action.payload.selectedItemId,
      loading: false,
      error: action.payload.error,
    }),
    clearCurrentLoadBalancingGroupAction: (state: LoadBalancingGroupState) => ({
      ...state,
      selectedItemId: undefined,
      loading: false,
      error: undefined,
      current: undefined,
    }),
  },
});

export const { actions: loadBalancingGroupActions, reducer: loadBalancingGroupReducers } = loadBalancingGroupSlice;
